const Star = ({ fill, outline, className }) => (
  <svg
    className={`starIcon icon ${className}`}
    preserveAspectRatio="xMinYMin meet"
    id="star-with-stroke"
    viewBox="0 0 105.42 100"
  >
    <path
      className={fill}
      d="M101.39,38.9a2.94,2.94,0,0,0-2.73-2L82,36.54l-9.77-.2-4.17-.08H66.2l-1-2.94L55.47,5.83a2.93,2.93,0,0,0-5.53,0L40.31,33.27l-1,2.94H37.35l-4.17.08-9.78.2-16.62.33a2.92,2.92,0,0,0-1.7,5.28L31,61.53l-9.45,30.8a2.87,2.87,0,0,0,1.83,3.62l0.08,0a0.55,0.55,0,0,1,.3.06,3.63,3.63,0,0,0,.6.09h0A2.65,2.65,0,0,0,24.9,96h0.3a2.87,2.87,0,0,0,.8-0.39L52.7,77.18l26.71,18.4a2.93,2.93,0,0,0,4.46-3.27L74.46,61.56l25.86-19.42A2.93,2.93,0,0,0,101.39,38.9Z"
    />
    <path
      className={outline}
      d="M81.07,100a6.77,6.77,0,0,1-3.87-1.2L52.7,82,28.2,98.8a6.53,6.53,0,0,1-1.84.9l-0.87.18a5.66,5.66,0,0,1-1.15.12H23.69l-0.54-.09-1-.21a6.76,6.76,0,0,1-4.42-8.48l8.6-28.14L2.72,45.25A6.81,6.81,0,0,1,6.67,33l29.82-.6,9.8-27.84a6.81,6.81,0,0,1,12.85,0l9.78,27.84L98.73,33a6.83,6.83,0,0,1,6.37,4.7h0a6.82,6.82,0,0,1-2.4,7.53L79,63l8.6,28.15A6.8,6.8,0,0,1,81.07,100ZM25.4,99.89h0Zm-2.73-.12L23,99.83Zm2.59-6.34h0Zm-1.47-1.05h0Zm57.83,0h0ZM52.7,72.5L79.36,90.85,70,60.1,95.81,40.7,63.38,40,52.71,9.67,42,40l-32.43.66,25.86,19.4L26.06,90.85Z"
    />
  </svg>
);

Star.propTypes = {
  fill: PropTypes.string,
  outline: PropTypes.string,
  className: PropTypes.string,
};

export default Star;
